var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissingQuotation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.707,22.293l-2.707-2.707V6c0-2.757-2.243-5-5-5h-8c-1.485,0-2.876.66-3.816,1.77L1.707.293C1.316-.098.684-.098.293.293S-.098,1.316.293,1.707l18.99,18.99c.007.007.013.013.02.02l2.99,2.99c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023,0-1.414ZM4.703,8.789c-.287-.284-.716-.367-1.088-.212-.372.155-.615.52-.615.923v10.767c0,1.126.676,2.121,1.722,2.537.33.131.671.194,1.01.194.737,0,1.459-.303,2-.875l4.281-4.762c.357-.397.339-1.005-.041-1.38l-7.269-7.192Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissingQuotation);
export default __webpack_public_path__ + "static/media/missing-quotation.968be95f7bcd6d44445c5243666e73b7.svg";
export { ForwardRef as ReactComponent };